export interface MapViewPadding {
  readonly left: number;
  readonly right: number;
  readonly top: number;
  readonly bottom: number;
}

const ZERO_PADDING: MapViewPadding = { left: 0, right: 0, top: 0, bottom: 0 };

const SDM_PANEL_SELECTOR = '.survey-data-viewer-modal:not(.minimized)';

function rectsIntersect(first: DOMRect, second: DOMRect): boolean {
  return (
    first.left < second.right &&
    first.right > second.left &&
    first.top < second.bottom &&
    first.bottom > second.top
  );
}

export function getOverlayPaddingOnMap(
  mapRect: DOMRect,
  overlayRect: DOMRect,
): MapViewPadding {
  if (!rectsIntersect(mapRect, overlayRect)) {
    return ZERO_PADDING;
  }

  const mapCenterX = mapRect.left + mapRect.width / 2;
  let left = 0;
  let right = 0;
  let top = 0;
  let bottom = 0;

  if (overlayRect.left < mapCenterX) {
    left = Math.max(0, Math.min(overlayRect.right, mapRect.right) - mapRect.left);
  }

  if (overlayRect.right > mapCenterX) {
    right = Math.max(0, mapRect.right - Math.max(overlayRect.left, mapRect.left));
  }

  if (overlayRect.top <= mapRect.top + 1 && overlayRect.bottom < mapRect.bottom - 1) {
    top = Math.max(0, Math.min(overlayRect.bottom, mapRect.bottom) - mapRect.top);
  }

  if (overlayRect.bottom >= mapRect.bottom - 1 && overlayRect.top > mapRect.top + 1) {
    bottom = Math.max(0, mapRect.bottom - overlayRect.top);
  }

  return { left, right, top, bottom };
}

/**
 * Padding for `view.goTo` so targets appear centred in the visible map area.
 * Only accounts for floating overlays on `.xa-map-container`.
 */
export function getDashboardMapViewPadding(): MapViewPadding {
  const mapContainer = document.querySelector('.xa-map-container');
  if (!(mapContainer instanceof HTMLElement)) {
    return ZERO_PADDING;
  }

  const panel = document.querySelector(SDM_PANEL_SELECTOR);
  if (!(panel instanceof HTMLElement)) {
    return ZERO_PADDING;
  }

  return getOverlayPaddingOnMap(
    mapContainer.getBoundingClientRect(),
    panel.getBoundingClientRect(),
  );
}
